// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"Accordion_accordionContainer__F7LAK"};